import { render, staticRenderFns } from "./dsly.vue?vue&type=template&id=68ae0dea&scoped=true"
import script from "./dsly.vue?vue&type=script&lang=js"
export * from "./dsly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae0dea",
  null
  
)

export default component.exports